import SplitButtonAuxiliary from "./SplitButtonAuxiliary.vue";
import { pluginify } from "./../../util";
export default pluginify(SplitButtonAuxiliary);
export { SplitButtonAuxiliary };
